import { render, staticRenderFns } from "./BaseAreaChart.vue?vue&type=template&id=b6effad8&scoped=true"
import script from "./BaseAreaChart.vue?vue&type=script&lang=js"
export * from "./BaseAreaChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6effad8",
  null
  
)

export default component.exports